export default {"src":"/_next/static/media/usdc.74c6aa75.svg","height":2000,"width":2000};